<script setup>
import HowToList from './HowToList.vue';
import HowToTitle from './HowToTitle.vue';
</script>

<template>
  <div class="cloud-calculator__how-to">
    <HowToTitle/>
    <HowToList/>
  </div>
</template>
